import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Interceptor global para unificar Backend y Frontend bajo el mismo dominio/puerto (preparación para Cloud/Nginx)
axios.interceptors.request.use(config => {
  if (config.url) {
    if (config.url.startsWith('/api/')) {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        config.url = `http://127.0.0.1:8000${config.url}`;
      } else {
        const apiOrigin = `${window.location.protocol}//${window.location.hostname}`;
        config.url = `${apiOrigin}${config.url}`;
      }
    } else if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      // Si estamos en la VM/Cloud (puerto 80 o 443), el backend está unificado bajo el mismo origen.
      const apiOrigin = `${window.location.protocol}//${window.location.hostname}`;
      config.url = config.url.replace(/http:\/\/(localhost|127\.0\.0\.1):8000/, apiOrigin);
    }
  }

  // Rutas públicas de tienda o web institucional donde NO se debe inyectar la empresa del operador del ERP
  const currentPath = typeof window !== 'undefined' ? (window.location.pathname || '').toLowerCase() : '';
  const isPublicWebOrStore = (
    currentPath === '/' ||
    currentPath.startsWith('/tienda') ||
    currentPath.startsWith('/landing') ||
    currentPath.startsWith('/home-web') ||
    currentPath.startsWith('/empresa') ||
    currentPath.startsWith('/donde-estamos') ||
    currentPath.startsWith('/contacto') ||
    currentPath.startsWith('/novedades') ||
    currentPath.startsWith('/descargas')
  );

  // Si se pasó ?company= en la URL (ej. previsualización desde el ERP), recordarlo en la pestaña
  const urlCompany = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('company') : null;
  if (urlCompany && typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem('previewCompanyId', String(urlCompany));
  }
  const isErpLogged = typeof localStorage !== 'undefined' && localStorage.getItem('isLogged') === 'true';
  const previewOrTabCompany = urlCompany || (typeof sessionStorage !== 'undefined' ? (sessionStorage.getItem('previewCompanyId') || (isErpLogged ? sessionStorage.getItem('tabCompanyId') : null)) : null);

  // Inyectar X-Company-ID y query param si el usuario está logueado en el ERP o hay una empresa seleccionada en la pestaña
  const userDataStr = (!isPublicWebOrStore || isErpLogged) ? (sessionStorage.getItem('tabUserData') || localStorage.getItem('userData')) : null;
  const fallbackCompanyId = previewOrTabCompany ? String(previewOrTabCompany) : '';
  if (userDataStr || fallbackCompanyId) {
    try {
      const userData = userDataStr ? JSON.parse(userDataStr) : null;
      const companyId = String(
        urlCompany ||
        window.__ACTIVE_COMPANY_ID__ ||
        sessionStorage.getItem('tabCompanyId') ||
        sessionStorage.getItem('previewCompanyId') ||
        userData?.empresa_activa?.c_nuges ||
        userData?.empresa_activa?.id ||
        ''
      );
      if (companyId && companyId !== 'undefined' && companyId !== 'null') {
        if (config.headers && typeof config.headers.set === 'function') {
          if (!config.headers.get('X-Company-ID') && !config.headers.get('x-company-id')) {
            config.headers.set('X-Company-ID', companyId);
          }
        } else {
          config.headers = config.headers || {};
          if (!config.headers['X-Company-ID'] && !config.headers['x-company-id']) {
            config.headers['X-Company-ID'] = companyId;
          }
        }

        // Inyectar parámetro de query 'company' para asegurar que el backend lo reciba
        if (config.url && config.url.includes('/api/')) {
          config.params = config.params || {};
          if (config.params.company === undefined && config.params.company_id === undefined) {
            config.params.company = companyId;
          }
        }
      }

      if (userData && userData.token) {
        if (config.headers && typeof config.headers.set === 'function') {
          if (!config.headers.get('Authorization')) {
            config.headers.set('Authorization', `Token ${userData.token}`);
          }
        } else {
          config.headers = config.headers || {};
          if (!config.headers['Authorization']) {
            config.headers['Authorization'] = `Token ${userData.token}`;
          }
        }
      }
    } catch (e) {
      console.error("Error procesando userData en interceptor de axios", e);
    }
  }

  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
